import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import tutorReducer from './slices/tutorSlice';
import brandingReducer from './slices/brandingSlice';
import rootSaga from './sagas';
import { errorMiddleware } from './middleware';

// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

// Configure store
export const store = configureStore({
  reducer: {
    tutor: tutorReducer,
    branding: brandingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
    }).concat(sagaMiddleware, errorMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});

// Run sagas
sagaMiddleware.run(rootSaga);

// Types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
